// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"20":"27f06a77872844df22b1","27":"1be4e2462607435a09a8","448":"0cff3424a0741f6aa440","476":"ac6333e401dca67bdb79","996":"6fdd5a438a884ebad82a"}[chunkId] + ".js";
};